var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"200px"}},[_c('v-row',{staticClass:"customTitle",staticStyle:{"font-size":"2em"}},[_vm._v(" Content ")]),_c('ProductMenu',{attrs:{"selectedComponent":_vm.selectedComponent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }